export default [
  {
    path: "*",
    meta: {
      public: true,
    },
    redirect: {
      path: "/404",
    },
  },
  {
    path: "/404",
    meta: {public: true},
    name: "NotFound",
    component: () => import(/* webpackChunkName: "routes" */ `@/views/NotFound.vue`),
    },
    {
    path: '/',
    meta: { public: true, },
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ '@/views/Login.vue')
    },
  {
    path: "/dashboard",
    meta: {
      breadcrumb: true,
      requiresAuth: true,
    },
    name: "Dashboard",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/Dashboard.vue`
      ),
  },

  //Menu de empleado
  {
    path: "/empleado/empleados",
    meta: {
      breadcrumb: true,
      requiresAuth: true,
    },
    name: "empleado/empleados",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/Empleados.vue`
      ),
  },
  {
    path: "/empleado/empleadosInactivos",
    meta: {
      breadcrumb: true,
      requiresAuth: true,
    },
    name: "empleado/empleadosInactivos",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/EmpleadosInactivos.vue`
      ),
  },
  {
    path: "/empleado/calendario",
    meta: {
      breadcrumb: true,
      requiresAuth: true,
    },
    name: "empleado/calendario",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/Calendario.vue`
      ),
  },
  {
    path: "/empleado/cumpleanios",
    meta: {
      breadcrumb: true,
      requiresAuth: true
    },
    name: "empleado/cumpleanios",
    component: () =>
      import(
        // webpackChunkName: "routes"
        `@/views/Cumpleanios.vue`
      ),
  },
  /* {
    path: "/empleado/detalleEmpleado/:paramIdEmpleado",
    meta: {
      breadcrumb: true,
      requiresAuth: true
    },
    name: "empleado/detalleEmpleado",
    component: () =>
      import(
        `@/views/DetalleEmpleado.vue`
      ),
    props: true,
  }, */
  {
    path: "/empleado/detalleEmpleado/",
    meta: {
      breadcrumb: true,
      requiresAuth: true,
    },
    name: "empleado/detalleEmpleado",
    component: () => import(`@/views/DetalleEmpleado.vue`),
    props: true,
  },

  //Menu de configuraciones
  {
    path: "/configuracion/clientes",
    meta: {
      breadcrumb: true,
      requiresAuth: true,
    },
    name: "configuracion/clientes",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/Clientes.vue`
      ),
  },
  {
    path: "/configuracion/empresas",
    meta: {
      breadcrumb: true,
      requiresAuth: true,
    },
    name: "configuracion/empresas",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/Empresas.vue`
      ),
  },
  {
    path: "/configuracion/sucursales",
    meta: {
      breadcrumb: true,
      requiresAuth: true,
    },
    name: "configuracion/sucursales",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/Sucursales.vue`
      ),
  },
  {
    path: "/configuracion/departamentos",
    meta: {
      breadcrumb: true,
      requiresAuth: true,
    },
    name: "configuracion/departamentos",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/Departamentos.vue`
      ),
  },

  //Menu de catalogos
  {
    path: "/catalogos/vacaciones",
    meta: {
      breadcrumb: true,
      requiresAuth: true,
    },
    name: "catalogos/vacaciones",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/Vacaciones.vue`
      ),
  },
  {
    path: "/catalogos/tipo_documentos",
    meta: {
      breadcrumb: true,
      requiresAuth: true,
    },
    name: "catalogos/tipo_documentos",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/TipoDocumentos.vue`
      ),
  },
  {
    path: "/catalogos/tipo_incidencias",
    meta: {
      breadcrumb: true,
      requiresAuth: true,
    },
    name: "catalogos/tipo_incidencias",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/TipoIncidencias.vue`
      ),
  },
  {
    path: "/catalogos/estatus_incidencias",
    meta: {
      breadcrumb: true,
      requiresAuth: true,
    },
    name: "catalogos/estatus_incidencias",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/EstatusIncidencias.vue`
      ),
  },
  {
    path: "/catalogos/estado_civil",
    meta: {
      breadcrumb: true,
      requiresAuth: true,
    },
    name: "catalogos/estado_civil",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/EstadosCiviles.vue`
      ),
  },
  {
    path: "/catalogos/configuracion_general",
    meta: {
      breadcrumb: true,
      requiresAuth: true,
    },
    name: "catalogos/configuracion_general",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/ConfiguracionesGenerales.vue`
      ),
  },
  {
    path: '/catalogos/tipo_acciones_disciplinarias',
    meta: { requiresAuth: true },
    name: 'catalogos/tipo_acciones_disciplinarias',
    component: () => import('@/views/TipoAccionesDisciplinarias.vue')
  },
  {
    path: '/catalogos/categoria_empleado',
    meta: { requiresAuth: true },
    name: 'catalogos/categoria_empleado',
    component: () => import('@/views/CategoriaEmpleado.vue')
  },
  //Menu de asisitencias
  {
    path: "/asistencia/registros",
    meta: {
      breadcrumb: true,
      requiresAuth: true,
    },
    name: "asistencia/registros",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/Registros.vue`
      ),
  },
  {
    path: "/asistencia/historico_checadas",
    meta: {
      breadcrumb: true,
      requiresAuth: true,
    },
    name: "asistencia/historico_checadas",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/HistoricoChecadas.vue`
      ),
  },
  {
    path: "/asistencia/checador-webcam",
    meta: {
      breadcrumb: true,
      requiresAuth: true,
    },
    name: "checadorWebcam",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/ChecadorWebcam.vue`
      ),
  },

  {
    path: "/horarios",
    meta: {
      breadcrumb: true,
      requiresAuth: true,
    },
    name: "horarios",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/Horarios.vue`
      ),
  },
  {
    path: "/usuarios",
    meta: {
      breadcrumb: true,
      requiresAuth: true,
    },
    name: "usuarios",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/usuarios.vue`
      ),
  },
  {
    path: "/dispositivos",
    meta: {
      breadcrumb: true,
      requiresAuth: true,
    },
    name: "dispositivos",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/Dispositivos.vue`
      ),
  },
  {
    path: "/dias_festivos",
    meta: {
      breadcrumb: true,
      requiresAuth: true,
    },
    name: "dias_festivos",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/DiasFestivos.vue`
      ),
  },
  {
    path: "/conexion_dispositivo",
    meta: {
      breadcrumb: true,
      requiresAuth: true,
    },
    name: "conexion_dispositivo",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/ConexionDispositivo.vue`
      ),
  },
  {
    path: "/documentos",
    meta: {
      breadcrumb: true,
      requiresAuth: true,
    },
    name: "documentos",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/Documentos.vue`
      ),
  },
  {
    path: "/incidencias",
    meta: {
      breadcrumb: true,
      requiresAuth: true,
    },
    name: "incidencias",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/Incidencias.vue`
      ),
  },
  {
    path: "/asignacion_checador",
    meta: {
      breadcrumb: true,
      requiresAuth: true,
    },
    name: "asignacion_checador",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/AsignacionChecadorEmpleado.vue`
      ),
  },
  {
    path: "/checador_relacion",
    meta: {
      breadcrumb: true,
      requiresAuth: true,
    },
    name: "checador_relacion",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/EmpleadoChecador.vue`
      ),
  },
  {
    path: "/buscador/:search",
    meta: {
      breadcrumb: true,
      requiresAuth: true,
    },
    name: "buscador",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/Buscador.vue`
      ),
    props: true,
  },
  {
    path: "/notificaciones",
    meta: {
      breadcrumb: true,
      requiresAuth: true,
    },
    name: "notificaciones",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/Notificaciones.vue`
      ),
  },
 //rutas para el wizard de configuracion inicial
  {
    path: '/bienvenido',
    meta: { public:true},
    name: "bienvenida",
    component: () => import(/* webpackChunkName: "routes" */ `../views/Bienvenida.vue`),
  },
  {
    path: '/paso_uno',
    meta: { public:true},
    name: "Pasouno",
    component: () => import(/* webpackChunkName: "routes" */ `../views/InicioUno.vue`),
  },
  {
    path: '/paso_dos',
    meta: { public:true /*breadcrumb: true, requiresAuth: true, noRoot: true,*/},
    name: "Pasodos",
    component: () => import(/* webpackChunkName: "routes" */ `../views/InicioDos.vue`),
  },
  {
    path: '/paso_tres',
    meta: { public:true/*requiresAuth: true, noRoot: true,*/},
    name: "Pasotres",
    component: () => import(/* webpackChunkName: "routes" */ `../views/InicioTres.vue`),
  },
  {
    path: "/tipoJornada",
    meta: {
      breadcrumb: true,
      requiresAuth: true,
    },
    name: "TipoJornada",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/TipoJornada.vue`
      ),
  },
  {
    path: "/vistas",
    meta: {
      breadcrumb: true,
      requiresAuth: true,
    },
    name: "Vistas",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/Vistas.vue`
      ),
  },
  {
    path: "/puestos",
    meta: {
      breadcrumb: true,
      requiresAuth: true,
    },
    name: "Puestos",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/Puestos.vue`
      ),
  },
  {
    path: "/prestaciones",
    meta: {
      breadcrumb: true,
      requiresAuth: true,
    },
    name: "Prestaciones",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/Prestaciones.vue`
      ),
  },
  {
    path: "/cursos_capacitaciones",
    meta: {
      breadcrumb: true,
      requiresAuth: true,
    },
    name: "cursos_capacitaciones",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/CursosCapacitaciones.vue`
      ),
  },
  {
    path: "/detalleCapacitacion",
    meta: {
      breadcrumb: true,
      requiresAuth: true,
    },
    name: "detalleCapacitacion",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/DetalleCapacitacion.vue`
      ),
  },
  {
    path: '/contratos',
    meta: { requiresAuth: true },
    name: 'Contratos',
    component: () => import('@/views/CatalogoContratos.vue')
  },
  {
    path: '/cartas',
    meta: { requiresAuth: true },
    name: 'Cartas',
    component: () => import('@/views/CatalogoCartas.vue')
  },
  {
    path: '/graficasContratos',
    meta: { requiresAuth: true },
    name: 'GraficasContratos',
    component: () => import('@/views/GraficasContratos.vue')
  },
  {
    path: '/beneficiarios',
    meta: { requiresAuth: true },
    name: 'beneficiarios',
    component: () => import('@/views/Beneficiarios.vue')
  },
  {
    path: '/comidas/cocinas',
    meta: { requiresAuth: true },
    name: 'comidas-cocinas',
    component: () => import('@/views/comidas/Cocinas.vue')
  },
  {
    path: '/comidas/guisos',
    meta: { requiresAuth: true },
    name: 'comidas-guisos',
    component: () => import('@/views/comidas/Guisos.vue')
  },
  {
    path: '/comidas/complementos',
    meta: { requiresAuth: true },
    name: 'comidas-complementos',
    component: () => import('@/views/comidas/Complementos.vue')
  },
  {
    path: '/comidas/pedidos',
    meta: { requiresAuth: true },
    name: 'comidas-pedidos',
    component: () => import('@/views/comidas/Pedidos.vue')
  },
  {
    path: '/acciones_disciplinarias',
    meta: { requiresAuth: true },
    name: 'accionesDisciplinarias',
    component: () => import('@/views/AccionesDisciplinarias.vue')
  },
  //notificaciones contratos
  {
    path: '/notificacionesContratos',
    meta: { requiresAuth: true },
    name: 'notificacionesContratos',
    component: () => import('@/views/contratos/NotificacionesContratos.vue')
  },
  {
    path: '/permisosRoles',
    meta: { requiresAuth: true },
    name: 'permisos',
    component: () => import('@/views/PermisosRol.vue')
  },
  {
    path: '/permisosTipos',
    meta: { requiresAuth: true },
    name: 'permisosTipos',
    component: () => import('@/views/TiposPermisos.vue')
  },
  {
    path: '/permisosCategoria',
    meta: { requiresAuth: true },
    name: 'permisosCategoria',
    component: () => import('@/views/PermisosCategoria.vue')
  },
  {
    path: '/reportes/vacaciones',
    meta: { requiresAuth: true },
    name: 'infoVacaciones',
    component: () => import('@/views/Reportes/Vacaciones.vue')
  },
  {
    path: '/tarjetas_salud',
    meta: { requiresAuth: true },
    name: 'tarjetasSalud',
    component: () => import('@/views/Salud/TarjetasSalud.vue')
  },
 

];
